import { createStore } from "vuex";
import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";
import globalActionsModule from "./globalActions/index";
import peppolModule from "./peppol/index";
import exportModule from "./exporting/index";
import actionsScheduleModule from "./schedule/index";
import suppliergroupModule from "./suppliergroup/index";
import fileModule from "./file/index";
const env = window.environment;

const store = createStore({
  modules: {
    globalActions: globalActionsModule,
    peppol: peppolModule,
    exporting: exportModule,
    schedule: actionsScheduleModule,
    suppliergroup: suppliergroupModule,
    file: fileModule,
  },
  state() {
    return {
      API: {
        getFavIcon: "api/admin/favicon",
        updatePayment:
          "api/admin/supplier-groups/:supplierGroupId/payment-settings",
        paymentJobs: "api/admin/payment/jobs",
        continueIngestion: "api/ingestion/process/:supplierGroupId/continue",
        downloadMultiDocuments:
          "api/admin/supplier-groups/:supplierGroupId/retrieveFilesZipped",
        startPrintEasyPost:
          "api/admin/supplier-groups/:supplierGroupId/process-easypost",
        deleteFromLegalArchive:
          "api/admin/supplier-groups/:supplierGroupId/documents/delete",
        addPeppolIdentifier:
          "api/admin/supplier-groups/:supplierGroupId/legal-entities/:legalEntityNumber/peppol-identifiers",
        retrievePeppolInfo: "api/admin/peppol/smp/participant/:identifier",
        getHermesMigrationKey:
          "api/admin/peppol/hermes/migration-key/:identifier",
        migrateSmp: "api/admin/peppol/smp/migrate",
        createPeppolParticipant: "api/admin/peppol/smp/participant",
        createPeppolDocument: "api/admin/peppol/smp/document",
        deletePeppolDocument: "api/admin/peppol/smp/document",
        deletePeppolParticipant: "api/admin/peppol/smp/participant",
        reprocessIncomingDocs: "api/admin/peppol/documents/reprocess-incoming",
        peppolIngestion: "api/admin/ingestion/process-peppol",
        triggerPeppolIngestion: "api/ingestion/process-peppol",
        triggerAnafIngestion: "api/ingestion/process-anaf/:sgId",
        triggerAnafIngestionLe:
          "api/admin/supplier-groups/:supplierGroupId/legal-entities/:legalEntityId/anaf/incoming",
        triggerPostDropIngestion: "api/admin/post-drop/ingestion",
        editBillingInfo:
          "api/admin/supplier-groups/:supplierGroupId/legal-entities/:legalEntityNumber/billing-info",
        smpParticipants: "api/admin/peppol/smp/participants",
        uploadFile: "api/admin/supplier-groups/upload/files",
        reprocessXml: "api/admin/reprocess-xml",
        updateSgStatus: "api/admin/supplier-groups/:supplierGroupId/status",
        updateLeStatus:
          "api/admin/supplier-groups/:supplierGroupId/legal-entities/:legalEntityId/status",
        updateLegalEntityIngestionSettings:
          "api/admin/supplier-groups/:supplierGroupId/legal-entities/:legalEntityNumber/ingestion-settings",
        updateLegalEntityApiConfig:
          "api/admin/supplier-groups/:supplierGroupId/legal-entities/:legalEntityNumber/api-config",
        updateLegalEntityChannelSetings:
          "api/admin/supplier-groups/:supplierGroupId/legal-entities/:legalEntityNumber/channel-config",
        resetLEChannelSettings:
          "api/admin/supplier-groups/:supplierGroupId/legal-entities/:legalEntityNumber/channel-config",
        deleteLegalEntity:
          "api/admin/supplier-groups/:supplierGroupId/legal-entities/:legalEntityNumber",
        keycloakToken:
          env.data.keycloakUrl +
          "/realms/" +
          env.data.keycloakRealm +
          "/protocol/openid-connect/token",
        pauseApiIngestion:
          "api/admin/supplier-groups/:supplierGroupId/pause-api",
        pauseAllApiIngestion: "api/admin/pause-api",

        peppolConfigSg:
          "api/admin/supplier-groups/:supplierGroupId/peppol-config",
        peppolConfigLe:
          "api/admin/supplier-groups/:supplierGroupId/legal-entities/:legalEntityNumber/peppol-config",

        massResendPostmark: "api/admin/documents/batch-send/emails",
        markAsHandled: "api/admin/documents/batch/handle-errors",
        syncDnsRecordsPostmark: "api/admin/sync-domains",
        getDnsRecordsPostmark: "api/admin/domains?name=",
        createDnsRecordsPostmark: "api/admin/domains",

        pingRaspberryOffice: "api/admin/reader/office",
        pingRaspberrySven: "api/admin/reader/sven",

        addEnvironment:
          "api/admin/supplier-groups/:supplierGroupId/environment",
      },

      token: "",
      refreshToken: "",
      tokenIsValid: false,
      displayShowHtml: false,
      displayEditGeneral: false,
      displayEditPeppolDocuments: false,
      displayEditPayments: false,
      displayEditBranding: false,
      displayEditIngestion: false,
      displayEditExtraction: false,
      displayAddExtractionTemplate: false,
      displayEditSettings: false,
      displayEditPass: false,
      displayEditContactInfoAndHelp: false,
      displayEditEDI: false,
      displayEditMailChannel: false,
      displayEditPrint: false,
      displayEditReporting: false,

      displayEditMailTemplate: false,
      displayEditQRTemplate: false,
      displayEditOverlayTemplate: false,
      displayAddOverlayTemplate: false,
      displayAddMailTemplate: false,
      displayAddPreingestionTemplate: false,
      displayAddResendTemplate: false,
      displayAddPreingestionTemplate1: false,

      displayEditTacTemplate: false,
      displayEditInsertsTemplate: false,
      displayEditPreIngestion: false,
      displayEditResendTemplate: false,
      displayEditChannelMaintenance: false,
      displayEditPeppol: false,

      displayEditLeGeneral: false,
      displayEditLePayment: false,
      displayEditLeBankAccounts: false,
      displayEditLePeppolIdentifiers: false,
      displayEditBillingInfo: false,
      displayModifyPeppolDocument: false,

      displayAddExternalPortalLink: false,
      displayAddExtractionField: false,
      displayAddExtractionField2: false,
      displayAddExtractionField3: false,
      displayAddExtractionField4: false,
      displayAddExtractionField5: false,
      displayAddExtractionField6: false,
      displayAddReceiverMail: false,
      displayAddEmail: false,
      displayAddEdi: false,
      displayAddPrintJob: false,
      displayAddManual: false,
      displayAddQrText: false,
      displayAddQrImage: false,
      displayAddOverlayFile: false,
      displayAddOverlayFile1: false,
      displayAddLinkFontFile: false,

      displayAddInsertsTemplate: false,
      displayAddInsertsFile: false,
      displayAddLeBankAccount: false,
      displayAddSupplierGroup: false,
      displayAddLegalEntity: false,
      displayAddQrTemplate: false,
      displayAddQrImage1: false,
      displayAddPreingestionFile: false,
      displayAddPreingestionJsonFile: false,
      displayAddPreingestionJsonFile1: false,
      displayAddResendTemplateFile: false,
      displayAddResendTemplateFile1: false,

      allQrTemplateDeleted: false,

      viewHtmlContent: "",
      parentTacFile: "",
      parentInsertsFile: "",
      addedEditTacFile: {},
      addedEditInsertsFile: {},
      addedTemplateTacFile: {},
      addedTemplateInsertsFile: {},
      filterSG: "",
      filterSchedule: "",
      supplierGroups: [],
      activeSG: {},
      activeLE: {},
      activeSGTab: "General",
      printJobs: [],
      xsdFiles: [],
      ediFiles: {},
      tacFiles: [],
      tacFilesLE: [],
      insertFiles: [],
      insertFilesLE: [],
      receiverMail: {},
      receiverMailLE: {},
      bankAccounts: [],

      schedule: {},
      response: {},
      responseStatus: 0,
      tempFile: "",
      tempFileName: "",
      baseUrl: "",
      baseUrlNymusX: "",
      schedulerUrl: "api/scheduler/jobs",
      supplierGroupUrl: "api/admin/supplier-groups",
      legalEntityUrl: "api/admin/legal-entities/search",
      alert: {},
      csvResponse: "",
      ibanRegex:
        /^([A-Z]{2}[ '+'\\'+'-]?[0-9]{2})(?=(?:[ '+'\\'+'-]?[A-Z0-9]){9,30}$)((?:[ '+'\\'+'-]?[A-Z0-9]{3,5}){2,7})([ '+'\\'+'-]?[A-Z0-9]{1,3})?$/,
      emailRegex:
        /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/ /* /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/ */,
      urlRegex:
        /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{2,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/ /* /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g */,
      phoneNumberRegex:
        /^['+']?[(]?[0-9]{3}[)]?[-\s]?[0-9]{3}[-\s]?[0-9]{4,6}$/,
      //dummy trigger
      selectAllbool: false,
      //Status chain Create SG
      currentUser: {},
      statusCreateSG: 0,
      statusCreateRealm: 0,
      statusCreateClient: 0,
      statusCreateBuckets: 0,
      statusCreateFTP: 0,
      qrBoundary: { width: 300, height: 426 },
      bucketName: "",
      qrImageSize: {
        width: 0,
        height: 0,
      },
      errorAlert: {
        display: false,
        text: "Sorry, something went wrong. Try again later.",
      },
      extractionTemplates: [],
      extractionTemplateIds: [],
      cancelEditExtraction: false,
      uploadedFileUrl: "",
      legalEntityCreated: false,
      sgOverviewPageNumber: 1,
      selectedExtractionTemplateName: "",
      selectedQrTemplateName: "",
      selectedOverlayTemplateName: "",
      selectedPreIngestionTemplateName: "",
      selectedResendTemplateName: "",
      selectedMailTemplateName: "",

      overlayTemplateDeleted: false,

      statusesSG: [
        { status: "CREATED", translation: "Created", color: "#a1a1a1" },
        {
          status: "IMPLEMENTATION",
          translation: "Implementation",
          color: "#ffdf20",
        },
        { status: "HYPERCARE", translation: "Hypercare", color: "#ffdf20" },
        { status: "LIVE", translation: "Live", color: "#00a63e" },
        { status: "PARTNER", translation: "Partner", color: "#00a6f4" },
        { status: "NOT_PAID", translation: "Not paid", color: "#e7000b" },
      ],
      ediReceivingProviderData: [
        { id: 0, name: "Anaf" },
        { id: 1, name: "Arco" },
        { id: 2, name: "Ariba" },
        { id: 3, name: "Basware" },
        { id: 4, name: "ChorusPro" },
        { id: 5, name: "Coupa" },
        { id: 6, name: "Eks" },
        { id: 7, name: "Ksef" },
        { id: 8, name: "Mercurius" },
        { id: 9, name: "OpenPeppol" },
        { id: 10, name: "OpenPeppolGLN" },
        { id: 11, name: "Peppol" },
        { id: 12, name: "TradeShift" },
        { id: 13, name: "Tungsten" },
      ],
      sendingProvider: [
        { id: 0, name: "ADVALVAS" },
        { id: 1, name: "ANAF" },
        { id: 2, name: "BABELWAY" },
        { id: 3, name: "BASWARE" },
        { id: 4, name: "KSEF" },
        { id: 5, name: "NYMUS_PEPPOL" },
      ],
      docTypes: [
        { id: 0, name: "CAR_INSURANCE" },
        { id: 1, name: "CREDIT_NOTE" },
        { id: 2, name: "DUNNING" },
        { id: 3, name: "FISCAL" },
        { id: 4, name: "GENERIC" },
        { id: 5, name: "INVOICE" },
        { id: 6, name: "MANDATE_ONBOARDING" },
        { id: 7, name: "SALARY" },
        { id: 8, name: "SELFBILLING_INVOICE" },
        { id: 9, name: "SELFBILLING_CREDIT_NOTE" },
        { id: 10, name: "YEARLY" },
      ],
      templateReason: [
        { id: 1, name: "CHANNEL_ONBOARDING" },
        { id: 2, name: "ONBOARDING_MANDATES" },
        { id: 3, name: "PAYMENT" },
        { id: 4, name: "SPAIN_ANTIFRAUD" },
      ],
      offsetData: [
        { id: 0, name: 1 },
        { id: 1, name: 2 },
        { id: 2, name: -1 },
        { id: 2, name: -2 },
      ],
      overlayData: [
        { id: 0, name: "FIRST_PAGE_ONLY" },
        { id: 1, name: "LAST_PAGE_ONLY" },
        { id: 2, name: "OFFSET" },
      ],
      overlayMode: [
        { id: 0, name: "ALL_PAGES" },
        { id: 1, name: "FIRST_PAGE_ONLY" },
        { id: 2, name: "LAST_PAGE_ONLY" },
        { id: 3, name: "EVEN_PAGES_ONLY" },
        { id: 4, name: "ODD_PAGES_ONLY" },
      ],
      linkField: [
        { id: 1, name: "CHANNEL_CHOICE_ACCESS_CODE" },
        { id: 0, name: "MANDATE_ONBOARDING_ACCESS_CODE" },
      ],
      smpProviders: [{ id: 0, name: "SMP_NYMUS" }],
      documentTypeIdentifiers: [
        { id: 0, name: "BIS_BILLING_CREDIT_NOTE_V3" },
        { id: 1, name: "BIS_BILLING_INVOICE_V3" },
        { id: 2, name: "BIS_SELF_BILLING_CREDIT_NOTE_V3" },
        { id: 3, name: "BIS_SELF_BILLING_INVOICE_V3" },
        { id: 4, name: "CATALOGUE_3_0" },
        { id: 5, name: "CATALOGUE_RESPONSE_3_0" },
        { id: 6, name: "DESPATCH_ADVICE_3_0" },
        { id: 7, name: "INVOICE_RESPONSE_3_0" },
        { id: 8, name: "MESSAGE_LEVEL_RESPONSE_3_0" },
        { id: 9, name: "ORDER_3_0" },
        { id: 10, name: "ORDER_AGREEMENT_3_0" },
        { id: 11, name: "ORDER_CANCELLATION" },
        { id: 12, name: "ORDER_CHANGE" },
        { id: 13, name: "ORDER_RESPONSE_3_0" },
        { id: 14, name: "ORDER_RESPONSE_ADVANCED" },
        { id: 15, name: "PUNCH_OUT_3_0" },
        { id: 16, name: "END_USER_STATISTICS_REPORT" },
        { id: 17, name: "FRANCE_CII_BILLING_CIUS" },
        { id: 18, name: "FRANCE_CII_BILLING_EXTENDED" },
        { id: 19, name: "FRANCE_UBL_BILLING_CIUS_CREDIT_NOTE" },
        { id: 20, name: "FRANCE_UBL_BILLING_CIUS_INVOICE" },
        { id: 21, name: "FRANCE_UBL_BILLING_EXTENDED_CREDIT_NOTE" },
        { id: 22, name: "FRANCE_UBL_BILLING_EXTENDED_INVOICE" },
        { id: 23, name: "FRANCE_FACTURX" },
        { id: 24, name: "NL_CIUS_CREDIT_NOTE" },
        { id: 25, name: "NL_CIUS_G_ACCOUNT_INVOICE" },
        { id: 26, name: "NL_CIUS_INVOICE" },
        { id: 27, name: "TRANSACTION_STATISTICS_REPORT" },
      ],
      standardDocumentTypeIdentifiers: [
        { id: 0, name: "BIS_BILLING_CREDIT_NOTE_V3" },
        { id: 1, name: "BIS_BILLING_INVOICE_V3" },
        { id: 5, name: "INVOICE_RESPONSE_3_0" },
      ],
      peppolDocumentTypes: [
        { id: 0, name: "UBL" },
        { id: 1, name: "GENERATED_PDF" },
        { id: 2, name: "ATTACHMENTS_PDF" },
        { id: 3, name: "ATTACHMENTS_OTHER" },
        { id: 4, name: "ORIGINAL_CII" },
      ],
      peppolMessageType: [
        { id: 0, name: "All" },
        { id: 1, name: "Anaf" },
        { id: 2, name: "Billing" },
        { id: 3, name: "Catalogue" },
        { id: 4, name: "CatalogueResponse" },
        { id: 5, name: "Order" },
        { id: 6, name: "DespatchAdvice" },
        { id: 7, name: "InvoiceResponse" },
        { id: 8, name: "MessageLevelResponse" },
        { id: 9, name: "OrderAgreement" },
        { id: 10, name: "OrderCancellation" },
        { id: 11, name: "OrderChange" },
        { id: 12, name: "OrderResponse" },
        { id: 13, name: "OrderResponseAdvanced" },
        { id: 14, name: "PunchOut" },
        { id: 15, name: "SelfBilling" },
        { id: 16, name: "FranceBillingCius" },
        { id: 17, name: "FranceBillingExtended" },
        { id: 18, name: "FranceFacturX" },
        { id: 19, name: "FranceCdar" },
        { id: 20, name: "FranceCiiBillingCius" },
        { id: 21, name: "FranceCiiBillingExtended" },
        { id: 22, name: "Other" },
      ],
      peppolIdentifiers: {
        peppolInfoDisplay: false,
        displayCreateDocument: false,
        participantFound: false,
        participantNotFound: false,
        peppolRetrievedData: {
          peppolIdentifier: "",
          information: [],
        },
        peppolItemChanged: false,
        peppolDocumentCreated: false,
        peppolDocumentDeleted: false,
      },
      hermesKey: "",
      displayLoader: false,
      tabulator: {
        isClickBlocked: false,
        valueCopied: false,
      },
      tableFieldTypeData: [
        { id: 0, name: "TABLE_LINE_NET" },
        { id: 1, name: "TABLE_ITEM_DESCRIPTION" },
        { id: 2, name: "TABLE_LINE_VAT" },
        { id: 3, name: "TABLE_ITEM_QUANTITY" },
        { id: 4, name: "TABLE_ITEM_PRICE_PER_UNIT" },
        { id: 5, name: "TABLE_ITEM_REDUCTION" },
        { id: 6, name: "TABLE_ITEM_UNIT" },
        { id: 7, name: "TABLE_OTHER" },
      ],

      tableSummaryFieldTypeData: [
        { id: 0, name: "SUMMARY_TABLE_NET" },
        { id: 1, name: "SUMMARY_TABLE_VAT_PERCENTAGE" },
        { id: 3, name: "SUMMARY_TABLE_VAT_AMOUNT" },
        { id: 3, name: "SUMMARY_TABLE_OTHER" },
      ],

      addressesTypeData: [
        { id: 0, name: "SELECT TYPE" },
        { id: 1, name: "DELIVERY_ADDRESS" },
        { id: 2, name: "LEGAL_ADDRESS" },
        { id: 3, name: "POSTAL_ADDRESS" },
      ],
      overviewTableDataUpdated: false,

      smpParticipants: [],
      smpParticipantData: [],
      sgTableInitialPage: 1,
      peppolDataRetrieved: false,

      ingestionStatus: {},
      printStatus: {},
      pauseApiIngestionChanged: {},
      startArchive: false,
      fileUploaded: false,

      sftpMountFileUploaded: {
        pdf: false,
        xml: false,
        attachment: false,
      },
      reportingTypes: [
        "MAIL_ERRORS",
        "CHANNEL_DETAIL",
        "CHANNEL_ARCHIVED_DETAIL",
        "DOCUMENTS_HELD",
        "TRANSACTIONS",
        "MANDATES_OVERVIEW",
        "MANDATES_CHOICES",
        "CHANNEL_CHOICE",
        "POST_DROP",
        "SG_SPECIFIC_ERRORS",
        "UBL_STATUS_REPORT",
        "PEPPOL_FIRST",
      ],
    };
  },
  mutations: mutations,
  getters: getters,
  actions: actions,
});

export default store;
